import { render, staticRenderFns } from "./BuscadorField.vue?vue&type=template&id=2dacaf28&"
import script from "./BuscadorField.vue?vue&type=script&lang=js&"
export * from "./BuscadorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports